export default defineNuxtRouteMiddleware((to) => {
  const localePath = useLocalePath();
  const { debugMode } = useRuntimeConfig().public;
  if (debugMode) return;
  if (to.path === "/test") return navigateTo(localePath("/"));
});
